import { InsuranceWithProduct } from '@/services/insurances/insurances';

/**
 * Determines whether an insurance policy is currently active.
 *
 * An insurance policy is considered active if:
 * - It does not have an end date.
 * - The current date falls within the insurance period defined by the start and end dates.
 *
 * @param insurance - The insurance object containing policy details, including start and end dates.
 * @returns `true` if the insurance is active, otherwise `false`.
 */
export function isActiveInsurance(insurance: InsuranceWithProduct) {
  // If the insurance has no end date, it is active
  if (!insurance.insurance.endDate) {
    return true;
  }

  // Check if the current date is within the insurance period
  const now = new Date();
  const startDate = new Date(insurance.insurance.startDate);
  const endDate = new Date(insurance.insurance.endDate);

  return now >= startDate && now <= endDate;
}
